/**
 * Point d'entrée unique de l'horloge système côté web.
 *
 * Même partage qu'au serveur : les horodatages **probatoires** viennent de l'API, jamais
 * du navigateur, dont l'heure peut être fausse ou modifiée. Ce qui passe par ici est
 * purement présentationnel — quelle fenêtre de dates afficher — et reste remplaçable en
 * test plutôt que dispersé en appels directs.
 */
export function maintenant(): Date {
  // eslint-disable-next-line no-restricted-syntax -- point d'entrée unique et assumé de l'horloge du navigateur
  return new Date();
}
